import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
import { theme } from '../../themes/theme';
export default css `
    ${componentStyles}

    :host {
        display: block;
    }

    .sidebar-item {
        ${theme.cssBorderRadius('L')};
        ${theme.colors.cssColor('gray-500')};
        ${theme.texts.cssSubtitle};
        ${theme.spacings.cssPadding('XS')};
        cursor: pointer;
    }

    .sidebar-item:hover {
        ${theme.colors.cssBackground('neutral', 'hover')};
    }
`;
//# sourceMappingURL=sidebar-item.styles.js.map